const initialState = {
	canRedeemPoints: false,
	redeemPoints: false
};

const couponsReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'set-can-redeem-points':
			state = { ...state, canRedeemPoints: action.canRedeemPoints };
			break;
		case 'set-redeem-points':
			state = { ...state, redeemPoints: action.redeemPoints };
			break;
		default:
			state = { ...state };
			break;
	}
	return state;
};

export default couponsReducer;
